(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cn-brand-showcase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cn-brand-showcase')) customElements.define('cn-brand-showcase',class extends HTMLElement {
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();const options={signal:this.controller.signal};
    this.groups=[...this.querySelectorAll('[data-brand-group]')];this.brands=[...this.querySelectorAll('[data-brand]')];this.index=0;this.animations=[];this.transitionId=0;this.focused=false;this.visible=false;
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.motion.matches;
    this.toggle=this.querySelector('[data-toggle]');
    this.querySelector('.cb-controls').hidden=this.groups.length<2;
    this.querySelector('[data-back]').addEventListener('click',()=>this.show(this.index-1),options);
    this.querySelector('[data-forward]').addEventListener('click',()=>this.show(this.index+1),options);
    this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.updateToggle();this.schedule()},options);
    this.addEventListener('focusin',e=>{this.focused=e.target.matches(':focus-visible');this.schedule()},options);
    this.addEventListener('focusout',()=>queueMicrotask(()=>{this.focused=this.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');this.schedule()}),options);
    document.addEventListener('visibilitychange',()=>this.schedule(),options);
    document.addEventListener('shopify:block:select',e=>{const i=this.groups.findIndex(g=>g.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.updateToggle();this.show(i)}},options);
    this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule()},{threshold:0});this.observer.observe(this);
    this.updateToggle();this.show(0);
  }
  updateToggle(){this.toggle.setAttribute('aria-label',this.paused?this.toggle.dataset.play:this.toggle.dataset.pause);this.toggle.querySelector('span').textContent=this.paused?'▶':'Ⅱ'}
  show(i){
    if(!this.groups.length)return;
    const previous=this.index,next=(i+this.groups.length)%this.groups.length,token=++this.transitionId;
    this.animations.forEach(animation=>animation.cancel());this.animations=[];
    this.index=next;
    this.groups.forEach((group,n)=>{group.hidden=n!==next;group.inert=n!==next;group.setAttribute('aria-hidden',String(n!==next));group.style.zIndex=n===next?'1':'0'});
    this.brands.forEach((brand,n)=>brand.classList.toggle('is-active',n===next));
    this.querySelector('[data-counter]').textContent=String(next+1).padStart(2,'0')+' / '+String(this.groups.length).padStart(2,'0');
    [next,(next+1)%this.groups.length].forEach(n=>this.groups[n].querySelectorAll('img').forEach(img=>img.loading='eager'));
    if(previous!==next&&!this.motion.matches){
      const outgoing=this.groups[previous],incoming=this.groups[next],timing={duration:700,easing:'ease-in-out',fill:'both'};
      outgoing.hidden=false;
      this.animations=[outgoing.animate([{opacity:1},{opacity:0}],timing),incoming.animate([{opacity:0},{opacity:1}],timing)];
      Promise.all(this.animations.map(animation=>animation.finished)).then(()=>{
        if(token!==this.transitionId)return;
        outgoing.hidden=true;this.animations.forEach(animation=>animation.cancel());this.animations=[];
      }).catch(()=>{});
    }
    this.schedule();
  }
  schedule(){clearTimeout(this.timer);if(this.groups.length<2||this.paused||this.focused||!this.visible||document.hidden)return;this.timer=setTimeout(()=>this.show(this.index+1),5000)}
  disconnectedCallback(){clearTimeout(this.timer);this.transitionId++;this.animations?.forEach(animation=>animation.cancel());this.controller?.abort();this.observer?.disconnect();this.controller=null}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cn-delivery-map"] && !Shopify.designMode) return;
  try {
    if (typeof Intl.DisplayNames === "function") {
 const localizeDeliveryMap = () => { const names = new Intl.DisplayNames([document.documentElement.lang || "en"], { type: "region" }); document.querySelectorAll("[data-cm-country]").forEach(title => { title.textContent = names.of(title.dataset.cmCountry); }); };
 if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", localizeDeliveryMap, { once: true }); else localizeDeliveryMap();
 document.addEventListener("shopify:section:load", localizeDeliveryMap);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cn-stove-calculator"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('cn-stove-calculator'))customElements.define('cn-stove-calculator',class extends HTMLElement{
  connectedCallback(){if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.form=this.querySelector('form');this.openHandler=e=>{const button=e.target.closest('[data-stove-finder]');if(!button)return;this.opener=button;this.dialog.showModal();this.form.elements.area.focus()};document.addEventListener('click',this.openHandler);this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());this.dialog.addEventListener('close',()=>this.opener?.focus());this.form.addEventListener('input',()=>{this.querySelector('[data-result-box]').hidden=true;this.querySelector('[data-placeholder]').hidden=false});this.form.addEventListener('submit',e=>{e.preventDefault();if(!this.form.reportValidity())return;const data=new FormData(this.form),area=Number(data.get('area')),height=Number(data.get('height')),factor=Number(data.get('insulation'));if(!Number.isFinite(area*height)||area<=0||height<=0||![10,15,20].includes(factor))return;const kw=area*height/factor,min=Math.floor(kw*.8*10)/10,max=Math.ceil(kw*1.2*10)/10;this.querySelector('[data-output]').textContent=this.dataset.result.replace('[kw]',kw.toFixed(1));this.querySelector('[data-band]').textContent=this.dataset.band.replace('[min]',min.toFixed(1)).replace('[max]',max.toFixed(1));const url=new URL(this.dataset.catalog,location.origin);url.searchParams.set('cn_calc_min',min.toFixed(1));url.searchParams.set('cn_calc_max',max.toFixed(1));const category=data.get('category');if(category)url.searchParams.set('cn_category',category);url.searchParams.set('cn_insulation',factor);const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);url.hash='cc-results';this.querySelector('[data-models]').href=url.toString();this.querySelector('[data-placeholder]').hidden=true;const result=this.querySelector('[data-result-box]');result.hidden=false;result.focus({preventScroll:true});if(matchMedia('(max-width:749px)').matches)result.scrollIntoView({block:'center',behavior:'instant'})})}
  disconnectedCallback(){document.removeEventListener('click',this.openHandler)}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-modal"] && !Shopify.designMode) return;
  try {
    function initZoomGalleries() {
  document.querySelectorAll('product-modal').forEach(modal => {
    const nav = modal.querySelector('.cn-zoom-nav');
    if (!nav || nav.dataset.ready) return;
    nav.dataset.ready = 'true';
    const content = modal.querySelector('.product-media-modal__content');
    const slides = Array.from(content.children).filter(el => el.hasAttribute('data-media-id'));
    const count = nav.querySelector('.cn-zoom-count');
    nav.hidden = slides.length < 2;
    const currentIndex = () => Math.max(0, slides.findIndex(el => el.classList.contains('active')));
    const sync = () => { count.textContent = (currentIndex() + 1) + ' / ' + slides.length; };
    const move = step => {
      if (!modal.hasAttribute('open') || slides.length < 2) return;
      const next = (currentIndex() + step + slides.length) % slides.length;
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      slides.forEach((el, index) => el.classList.toggle('active', index === next));
      const media = slides[next];
      if (media.tagName === 'DEFERRED-MEDIA' && typeof media.loadContent === 'function') media.loadContent();
      content.scrollTop = 0;
      content.scrollLeft = 0;
      sync();
    };
    nav.addEventListener('pointerup', e => e.stopPropagation());
    nav.addEventListener('click', e => {
      const button = e.target.closest('[data-zoom-step]');
      if (button) { e.preventDefault(); e.stopPropagation(); move(Number(button.dataset.zoomStep)); }
    });
    modal.addEventListener('keydown', e => {
      if (!modal.hasAttribute('open') || /INPUT|TEXTAREA|SELECT/.test(e.target.tagName)) return;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault(); e.stopPropagation(); move(e.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    let start = null;
    content.addEventListener('touchstart', e => {
      start = e.touches.length === 1 ? {x:e.touches[0].clientX,y:e.touches[0].clientY} : null;
    }, {passive:true});
    content.addEventListener('touchend', e => {
      if (!start || !e.changedTouches.length) return;
      const dx = e.changedTouches[0].clientX - start.x;
      const dy = e.changedTouches[0].clientY - start.y;
      start = null;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) move(dx < 0 ? 1 : -1);
    }, {passive:true});
    content.addEventListener('touchcancel', () => {start = null;}, {passive:true});
    new MutationObserver(sync).observe(modal, {attributes:true,attributeFilter:['open']});
    sync();
  });
}
initZoomGalleries();
document.addEventListener('shopify:section:load', initZoomGalleries);
  } catch(e) { console.error(e); }
})();

})();
